import React from "react";
import "./privacy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Your privacy is important to us at FreshCart</p>
      </header>

      <main className="privacy-content">
        <p><strong>Last updated:</strong> October 2025</p>

        <h2>1. Introduction</h2>
        <p>
          Welcome to Shivneri Fresh! This Privacy Policy describes how we collect,
          use, and protect your personal information when you visit or make a
          purchase from our website.
        </p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, phone number, billing and shipping address.</li>
          <li><strong>Payment Information:</strong> Processed securely by our payment partners; we do not store your card details.</li>
          <li><strong>Usage Data:</strong> Information about how you browse our site (e.g., pages visited, time spent, device type).</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>To process your orders and deliver products.</li>
          <li>To communicate with you regarding your purchases and updates.</li>
          <li>To improve our website and customer service experience.</li>
          <li>To send promotional offers (only if you opt-in).</li>
        </ul>

        <h2>4. Cookies</h2>
        <p>
          We use cookies to enhance your shopping experience. You can disable
          cookies through your browser settings, but some site features may not
          function properly.
        </p>

        <h2>5. Data Protection</h2>
        <p>
          We use SSL encryption and secure servers to protect your personal
          data. Only authorized personnel can access your information for
          legitimate business purposes.
        </p>

        <h2>6. Sharing of Information</h2>
        <p>
          We do not sell your personal information. We may share data with
          trusted service providers (e.g., delivery partners, payment
          processors) only to complete transactions.
        </p>

        <h2>7. Your Rights</h2>
        <ul>
          <li>Access and update your personal information.</li>
          <li>Request deletion of your data.</li>
          <li>Withdraw consent for marketing communications at any time.</li>
        </ul>

        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy occasionally to reflect changes in
          our practices or for legal reasons. Updates will be posted on this
          page with the revised date.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us:
        </p>
        <p>
          <strong>Email:</strong> support@freshmart.com<br />
          <strong>Phone:</strong> +91 98673 78209<br />
          <strong>Address:</strong> A, Yogi Executive Hotel, 4, MAFCO MARKET, Sector 18, Vashi, Navi Mumbai, Maharashtra 400703
        </p>
      </main>

      <footer className="privacy-footer">
        &copy; 2025 Shivneri Fresh. All rights reserved.
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
